<template>
<div
    style="text-align: right"
>
    <v-slider
        :min="150"
        :max="600"
        :step="50"
        label="Image Size"
        v-on:input="onChange" 
        :value="value"
    >
    </v-slider>

</div>
</template>

<script>
export default {
    props: {
        value: {
            type: Number,
            default: function() { return 300; }
        },
    },

    methods: {
        onChange(value) {
            this.$emit('input', value);
        }
    },
}
</script>

<style lang="scss" scoped>

</style>